<template>
    <div id="pwa-intervention" class="mx-2">
        <button-go-back text="Détails intervention"></button-go-back>
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">

                <div class="intervention-details__card relative">
                    <p class="font-medium mb-2 text-sm">Signature</p>
                    <md-divider class="mb-1 -mt-1 -mx-2"></md-divider>
                    <VueSignaturePad ref="signaturePad" width="100%" height="200px" />
                    <md-divider class="mb-1 mt-1 -mx-2"></md-divider>
                    <div class="flex items-center space-x-2 pt-1 pb-1.5">
                        <md-button class="md-icon-button md-raised md-warning my-0" @click="undo">
                            <span class="font-medium leading-none">Retour</span>
                        </md-button>
                        <md-button class="md-icon-button md-raised md-danger my-0" @click="clear">
                            <span class="font-medium leading-none">Effacer</span>
                        </md-button>
                    </div>
                    <div class="overlay-signature" :class="{'active': noSignatory}"></div>
                </div>

                <div class="intervention-details__card mt-2">
                    <p class="font-medium mb-2 text-sm">Formulaire</p>
                    <md-divider class="mb-1 -mt-1 -mx-2"></md-divider>
                    <div class="px-2 pt-1">
                        <div class="md-multiselect">
                            <label>Signataire</label>
                            <multiselect v-model="signatory"
                                         :options="contacts"
                                         :disabled="noSignatory === 1 || isOtherSignatory"
                                         :searchable="false"
                                         :show-labels="false"
                                         group-values="contacts"
                                         group-label="type"
                                         placeholder="Contact"
                                         label="full_name"
                                         track-by="id">
                                <template slot="noOptions">La liste est vide</template>
                                <template slot="noResult">Aucun élement correspondant</template>
                            </multiselect>
                        </div>
                        <md-radio v-model="isOtherSignatory" :value="true" :disabled="noSignatory === 1" class="mb-1 mt-1 text-sm">Autre signataire</md-radio>
                        <md-field class="md-invalid mb-2.5 mt-3.5" v-if="isOtherSignatory">
                            <label>Signataire</label>
                            <md-input v-model="otherSignatory" type="text" />
                            <validation-error :errors="apiValidationErrors.otherSignatory" />
                        </md-field>
                    </div>
                    <md-divider class="my-2 -mx-2"></md-divider>
                    <div class="px-2 pt-1">
                        <md-radio v-model="noSignatory" :value="1" class="my-1 mt-0 text-sm">Pas de signataire</md-radio>
                        <md-radio v-model="noSignatory" :value="2" class="my-1 text-sm">Absence de signature (Covid-19)</md-radio>
                        <div v-if="needSignature" class="text-danger font-medium text-2xs leading-3">La signature est obligatoire ou sélectionner "Absence de signature (Covid-19)"</div>
                        <div v-if="needSignatory" class="text-danger font-medium text-2xs leading-3">Le signataire est obligatoire ou sélectionner "Pas de signataire"</div>
                    </div>
                    <md-divider class="my-2 -mx-2"></md-divider>
                    <div class="mb-1.5 flex items-center justify-between">
                        <md-button class="md-danger md-icon-button md-raised my-0" type="submit" @click="clearForm">
                            <span class="leading-none font-medium">Recommencer</span>
                        </md-button>
                        <md-button class="md-success md-icon-button md-raised my-0" type="submit" @click="checkValidation" :disabled="loading">
                            <font-awesome-icon class="md-icon" :icon="['fa', loading ? 'sync-alt' : 'check-circle']" :class="{'animate-spin': loading}" />
                            <span class="leading-none font-medium ml-2">Ajouter la signature</span>
                        </md-button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import ButtonGoBack from "../components/ButtonGoBack";

import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import indexedDBMixin from "@/mixins/indexed-db-mixin";

import { mapState } from "vuex";

export default {
    name: "PwaInterventionSignature",
    components: { ButtonGoBack, ValidationError },
    mixins: [formMixin, indexedDBMixin],
    data() {
        return {
            noSignatory: false,
            isOtherSignatory: false,
            otherSignatory: '',
            signatory: null,
            contacts: [],
            needSignature: false,
            needSignatory: false,
	        loading: false
        }
    },
    computed: mapState({
        user: state => state.pwaAuth.technician,
    }),
    methods: {
        async getContacts() {
	        const contacts = await this.fetchDataFromIndexedDB(`pwa/intervention/${this.$route.params.interventionId}/contacts`)
            if(Object.entries(contacts.value).length > 0) {
                for (const [key, value] of Object.entries(contacts.value)) {
                    this.contacts.push(value)
                }
                this.signatory = contacts.value['Contact RDV'].contacts[0]
            } else {
                this.noSignatory = 1
            }
        },
        undo() {
            this.$refs.signaturePad.undoSignature()
        },
        clear() {
            this.$refs.signaturePad.clearSignature()
        },
        clearForm() {
            this.signatory = this.contacts.length > 0 ? this.contacts[0].contacts[0] : null
            this.noSignatory = false
            this.needSignature = false
            this.needSignatory = false
            this.isOtherSignatory = false
            this.otherSignatory = ''
            this.resetApiValidation()
            this.clear()
        },
        checkValidation() {
            let errors = []
            this.resetApiValidation()

            if(!this.noSignatory && (this.isOtherSignatory && (!this.otherSignatory || this.otherSignatory === ''))) {
                errors.push({
                    source: { pointer: '/data/attributes/otherSignatory' },
                    detail: 'Le signataire est obligatoire'
                })
            }

            if(errors.length > 0) {
                this.setApiValidation(errors)
            } else {
                this.submitSignature()
            }
        },
        async submitSignature() {
			this.loading = true
            this.needSignature = false
            this.needSignatory = false

	        // Get signature data
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
            if(isEmpty && !this.noSignatory) {
                this.needSignature = true
            } else {
                if((!this.signatory && this.noSignatory !== 1) && !this.isOtherSignatory) {
                    this.needSignatory = true
                } else {
                    let signature
                    const date = this.$moment(new Date())
                    const signatory = this.noSignatory === 1 || this.isOtherSignatory ? 'null' : this.signatory.id
                    const noSignatory = this.noSignatory === 1 ? '1' : this.noSignatory === 2 ? '2' : '0'
                    const otherSignatory = this.isOtherSignatory ? this.otherSignatory : 'null'

                    if(isEmpty) {
                        signature = JSON.stringify({
                            date: date,
                            signatoryId: signatory,
                            noSignatory: noSignatory,
                            otherSignatory: otherSignatory,
                            signature: 'null'
                        })
                    } else {
                        signature = JSON.stringify({
                            date: date,
                            signatoryId: signatory,
                            noSignatory: noSignatory,
                            otherSignatory: otherSignatory,
                            signature: data
                        })
                    }

	                const payload = {
		                access_token: JSON.parse(localStorage.getItem('pwa')).access_token,
		                user_id: this.user.id,
		                report_signature: signature
	                }

                    try {
						const intervention = await this.fetchDataFromIndexedDB(`pwa/intervention/${this.$route.params.interventionId}`)
	                    intervention.value.report = { ...intervention.value.report, report_signature: payload }

						const db = await this.getIndexedDBConnection()
	                    const tx = db.transaction('data', 'readwrite')
	                    const store = tx.objectStore('data')
	                    store.put({ key: `pwa/intervention/${intervention.value.id}`, value: intervention.value })

	                    await this.storeRequest(`pwa/planning/${intervention.value.id}/report/signature`, payload)
                        await this.$store.dispatch('alerts/success', 'Signature ajoutée')
                        this.$router.back()
                    } catch (e) {}
                }
            }
			this.loading = false
        }
    },
    mounted() {
        this.getContacts()
    },
    watch: {
        noSignatory(newVal) {
            this.needSignatory = false
            if(newVal === 1) {
                this.signatory = null
	            this.isOtherSignatory = false
	            this.otherSignatory = ''
            } else if(newVal === 2 && !this.isOtherSignatory) {
                // si un signataire est déjà selectionné, on ne le remplace par le premier de la liste (si il y a des contacts, sinon on le passe a null)
                this.signatory = this.signatory === null ? (this.contacts.length > 0 ? this.contacts[0].contacts[0] : null) : this.signatory
                this.clear()
            }
        },
        isOtherSignatory(newVal) {
            if(newVal) {
                this.signatory = null
            }
        }
    }
}
</script>

<style scoped lang="scss">
.overlay-signature {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: $gray-light;
    opacity: 0.5;
    border-radius: 3px;
    display: none;

    &.active {
        z-index: 15;
        display: block;
    }
}
</style>
